const URIs = {
  SIGNUP: {
    ROUTE_PATH: 'auth',
    END_POINTS: {
      GET_VERIFICATION_CODE: '/sendVerificationCode',
      VERIFY_DOMAIN: '/verifyDomain',
    },
  },
  PROFILE: {
    ROUTE_PATH: '',
    END_POINTS: {
      UPDATE_PROFILE: '/profile',
      GET_PROFILE: '/profile',
    },
  },
  TEAM_BUILDER: {
    ROUTE_PATH: 'team-builder',
    END_POINTS: {
      GET_PROJECTS: '/projects',
      GET_MEMBERS: '/members',
      UPDATE_PROJECTS: '/project-assigned',
      GET_STAFFING_REQUIREMENTS: '/projects/get-staffing-req',
      UPDATE_STAFFING_REQUIREMENTS: '/projects/staffing-req-creation',
    },
  },
  TIMELINE: {
    ROUTE_PATH: 'timeline',
    END_POINTS: {
      GET_TIMELINE: '/get-timeline',
    },
    PARAMS: {
      BY_HOURS_VIEW: 'hourly_view=true',
      BY_PROJECTS_VIEW: 'project_view=true',
    },
  },
  META_DATA: {
    ROUTE_PATH: '',
    END_POINTS: {
      GET_ALL_FILTERS: '/get-meta',
    },
  },
};

export default URIs;
